import { Box, Flex, IconButton, Text, HStack, Badge, Button, Avatar, AvatarGroup, Tooltip } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChecklistItemViewModel } from "./types";

interface ChecklistItemProps {
  checklistItem: ChecklistItemViewModel;
  onEdit: (checklistItem: ChecklistItemViewModel) => void;
  onUpdate: (checklistItem: ChecklistItemViewModel) => void;
  onDelete: (checklistItem: ChecklistItemViewModel) => void;
  onManageAssignments: (checklistItem: ChecklistItemViewModel) => void;
  canEdit: boolean;
}

export function ChecklistItem({
  checklistItem,
  onEdit,
  onUpdate,
  onDelete,
  onManageAssignments,
  canEdit,
}: ChecklistItemProps) {
  return (
    <Box
      p={2}
      borderWidth="1px"
      borderRadius="md"
      mb={2}
      _hover={{ bg: "gray.50" }}
    >
      <Flex direction={{ base: "column", md: "row" }} gap={2}>
        <HStack spacing={2} flex="1" minW="0">
          <Text fontWeight="500" fontSize="14px" noOfLines={1} flex="1">
            {checklistItem.title}
          </Text>
          {checklistItem.category && (
            <Badge colorScheme="purple" variant="subtle" fontSize="12px">
              {checklistItem.category}
            </Badge>
          )}
        </HStack>
        <HStack spacing={2} justify="flex-end" flexShrink={0}>
          {checklistItem.assigned_users && checklistItem.assigned_users.length > 0 && (
            <Tooltip label={checklistItem.assigned_users.map(user => `${user.first_name} ${user.last_name}`).join(", ")}>
              <AvatarGroup size="xs" max={2}>
                {checklistItem.assigned_users.map(user => (
                  <Avatar
                    key={user.id}
                    name={`${user.first_name} ${user.last_name}`}
                    size="xs"
                  />
                ))}
              </AvatarGroup>
            </Tooltip>
          )}
          {canEdit && (
            <>
              <Button
                size="xs"
                variant="ghost"
                onClick={() => onManageAssignments(checklistItem)}
                leftIcon={<FontAwesomeIcon icon={["far", "users"]} />}
              >
                Assign
              </Button>
              <IconButton
                aria-label="edit-checklist-item"
                icon={<FontAwesomeIcon icon={["far", "pencil"]} />}
                variant="ghost"
                size="xs"
                onClick={() => onEdit(checklistItem)}
                color="gray.500"
                _hover={{ color: "primary" }}
              />
              <IconButton
                aria-label="delete-checklist-item"
                icon={<FontAwesomeIcon icon={["far", "trash"]} />}
                variant="ghost"
                size="xs"
                onClick={() => onDelete(checklistItem)}
                color="gray.500"
                _hover={{ color: "red.500" }}
              />
            </>
          )}
        </HStack>
      </Flex>
    </Box>
  );
} 